"use client";
import { AdTags } from "@/components/ad-tags";
import { Toaster } from "@/components/ui/sonner";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen">
      <AdTags />
      {children}
      <Toaster />
    </div>
  );
}
